var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ConfigMenuComponent_1;
import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { Icon } from '../../utils/icon-utils.js';
import { Router } from '../../utils/router.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { Translate } from '../../utils/translate.js';
import { customElement } from 'lit/decorators.js';
let ConfigMenuComponent = class ConfigMenuComponent extends GGOBaseComponent {
    static { ConfigMenuComponent_1 = this; }
    static { this.properties = {
        title: { type: String },
        menuItems: { type: Array }, // Liste des items du menu
        selectedItem: { type: Object }, // Item sélectionné
    }; }
    constructor() {
        super();
        this.menuItems = [];
        this.selectedItem = undefined;
    }
    selectItem(item) {
        for (let item of this.menuItems) {
            item.selected = false;
        }
        item.selected = true;
        this.selectedItem = item;
    }
    handleMenuClick(item) {
        console.log('handleMenuClick', item);
        this.selectItem(item);
        if (this.router !== undefined) {
            this.router.loadRoute(this.selectedItem.label);
        }
    }
    updateFirst(changedProperties) {
        this.selectedItem = this.menuItems[0];
        this.selectedItem.selected = true;
    }
    setRoutes() {
        if (this.router === undefined && this.menuItems?.length > 0) {
            const routes = [
                {
                    // default route
                    path: '',
                    callback: () => {
                        this.selectItem(this.menuItems[0]);
                    },
                },
            ];
            for (let item of this.menuItems) {
                routes.push({
                    path: '' + item.label,
                    callback: () => {
                        this.selectItem(item);
                    },
                });
            }
            this.router = new Router(routes);
        }
    }
    static getContent(item) {
        let content;
        if (item?.getContent !== undefined) {
            content = item.getContent();
        }
        if (item?.content !== undefined) {
            content = item.content;
        }
        if (content === undefined) {
            content = html `<div>Content not found</div>`;
        }
        if (typeof content === 'string') {
            content = unsafeHTML(content);
        }
        return content;
    }
    static getIconTag1(item) {
        if (!item.icon) {
            item.icon = 'utility:apps';
        }
        const split = item.icon.split(':');
        return Icon.getSVGIconTag({
            icon: split[1],
            sprite: split[0],
            classes: ['slds-icon', 'slds-icon-text-default', 'slds-icon_x-small', 'slds-m-right_x-small'],
        });
    }
    static getIconTag2(item) {
        if (!item.icon) {
            item.icon = 'utility:apps';
        }
        const split = item.icon.split(':');
        return Icon.getSVGIconTag({ icon: split[1], sprite: split[0], classes: ['slds-icon', 'slds-page-header__icon'] });
    }
    render() {
        console.log('ConfigMenuComponent render', this.menuItems);
        this.setRoutes();
        if (this.selectedItem === undefined) {
            return html `<div>${Translate.get('config_menu_loading')}</div>`;
        }
        return html `
      <div style="display:flex; height: 100%;">
        <div id="sections_panel" class="slds-panel slds-size_small slds-panel_docked slds-panel_docked-left slds-is-open" aria-hidden="false">
          <div class="slds-panel__body slds-p-around_none">
            <nav class="slds-nav-vertical" aria-label="Sub page">
              <div class="slds-nav-vertical__section">
                <ul>
                  ${this.menuItems.map((item) => html ` <li class="slds-nav-vertical__item ${item.selected ? 'slds-is-active' : ''}" @click="${() => this.handleMenuClick(item)}">
                        <span class="slds-nav-vertical__action">
                          <span class="slds-icon_container slds-icon-utility-open_folder slds-line-height_reset" title="Folder">
                            ${ConfigMenuComponent_1.getIconTag1(item)}
                            <span class="slds-assistive-text">${item.label}</span>
                          </span>
                          ${item.label}
                        </span>
                      </li>`)}
                </ul>
              </div>
            </nav>
          </div>
          <div class="slds-p-horizontal_small" style="position: absolute; bottom: 0"></div>
        </div>
        <div id="outlet" class="slds-p-horizontal_small outlet_container" style="width:100%; overflow: auto;">${this.getBody()}</div>
      </div>
    `;
    }
    getBody() {
        return html `
      <div class="slds-page-header no-bottom-radius">
        <div class="slds-page-header__row">
          <div class="slds-page-header__col-title">
            <div class="slds-media">
              <div class="slds-media__figure">
                <span class="slds-icon_container slds-icon-standard-bundle-config"> ${ConfigMenuComponent_1.getIconTag2(this.selectedItem)} </span>
              </div>
              <div class="slds-media__body">
                <div class="slds-page-header__name">
                  <div class="slds-page-header__name-title">
                    <h1>
                      <span class="slds-page-header__title slds-truncate" title="App Resume">${this.selectedItem?.label}</span>
                    </h1>
                  </div>
                </div>
                <p class="slds-page-header__name-meta"></p>
              </div>
            </div>
          </div>
          <div class="slds-page-header__col-actions">
            <div class="slds-page-header__controls">
              <div class="slds-page-header__control">
                <ul class="slds-button-group-list"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="settings-content slds-m-vertical_small">${html `${ConfigMenuComponent_1.getContent(this.selectedItem)}`}</div>
    `;
    }
};
ConfigMenuComponent = ConfigMenuComponent_1 = __decorate([
    customElement('ggo-config-menu')
], ConfigMenuComponent);
export { ConfigMenuComponent };
